import React from "react";
import { useSelector } from "react-redux";
import { InputArea } from "./InputArea";

/**
 * InputAreaWrapper
 *
 * This wrapper provides key-based component isolation to prevent InputArea from
 * remounting when parent component re-renders due to message updates.
 *
 * The key is based on selectedLead.id from Redux, so the component only remounts
 * when the actual lead changes, not when selectedLead object reference changes.
 *
 * Combined with React.memo in InputArea, this prevents input clearing on scroll.
 */
export const InputAreaWrapper = props => {
  // Get selectedLead.id directly from Redux with shallow comparison
  // This ensures wrapper only re-renders when ID actually changes, not on object reference changes
  const selectedLeadId = useSelector(
    state => state.lead.selectedLead?.id,
    (prev, next) => prev === next
  );

  // Use key to control component lifecycle - only remount when lead ID changes
  // InputArea's React.memo will handle preventing re-renders from other prop changes
  return <InputArea key={selectedLeadId || "no-lead"} {...props} />;
};
